import * as yup from 'yup'
import { emptyStringToZero, trimString } from 'common/utils/yupSchemaUtils'
import { getStandardizedName } from 'common/utils/stringUtils'
import { accessDurationOptions } from './AccessDurationInput'

export const MIN_PRODUCT_PRICE = 499
export const schema = yup
  .object({
    stripeProductName: yup
      .string()
      .required('Name required')
      .min(3, 'Name must be at least 3 characters')
      .max(30, 'Name must be under 30 characters')
      .transform(trimString),
    description: yup.string().max(200, 'Description must be under 200 characters'),
    slug: yup.string().required('Link required').test('duplicate', checkDuplicateSlugs),
    price: yup
      .number()
      .transform(emptyStringToZero)
      .required('Price should be at least 4.99')
      .min(MIN_PRODUCT_PRICE, 'Price should be at least 4.99'),
    accessDuration: yup.string(),
    accessValue: yup
      .number('Should be at least 1')
      .transform(emptyStringToZero)
      .when('accessDuration', ([accessDuration], schema) => {
        if (accessDuration === accessDurationOptions.period) {
          return schema.required('Should be at least 1').min(1, 'Should be at least 1')
        } else {
          return schema
        }
      }),
    previewImg: yup.string(),
  })
  .required()

function checkDuplicateSlugs(slug, { options, createError }) {
  const oneTimeProductSlugs = options.context.oneTimeProductSlugs
  const stdSlug = getStandardizedName(slug)
  if (oneTimeProductSlugs?.[stdSlug]) {
    return createError({
      message: `Link is already used by a different product`,
    })
  } else {
    return true
  }
}
